import React from 'react';
import { AddCaseAssessments } from 'pages/components';

const CasesAddAssessments = (props) => (
  <AddCaseAssessments {...props} />
);

export default CasesAddAssessments;
